module.exports = __webpack_public_path__ + "img/009-pumpkin.a0e6e0ab.png";